import React, { useState, useRef } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  TextField,
} from "@mui/material";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import BlackList from "../../services/blacklist/Blacklist";

const ImportContacts = (props) => {
  const [centeredModal, setCenteredModal] = useState(false);
  const [csvFile, setCsvFile] = useState("No File Selected");
  const [base64String, setBase64String] = useState("");
  const [Errormsg, setErrormsg] = useState("");
  const currentUserData = useSelector((state) => state.profile.profile);
  const fileInputRef = useRef(null);

  const closeModal = () => {
    setCenteredModal(false);
  };

  const searchSchema = Yup.object().shape({
    group: Yup.mixed().required("Cannot be empty"),
  });

  function onChangeXLSXFile(e) {
    const file = e.target.files[0];
    const fileName = file.name;
    const fileType = fileName.slice(
      ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
    );

    if (fileType !== "csv") {
      setErrormsg("Please select a CSV file.");
      e.target.value = null; // Clear the file input
    } else {
      setErrormsg(""); // Reset error message
    }

    if (file) {
      setCsvFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        setBase64String(base64);
      };
      reader.readAsDataURL(file);
    }
  }

  const handleXlSXUpload = async () => {
    if (base64String === "") {
      setErrormsg("Cannot be empty");
    } else {
      const splitImgString = base64String.split(",");
      const formData = new FormData();
      formData.append("enquiryxlxs", csvFile);
      formData.append("base64String", splitImgString[1]);
      formData.append(
        "user_id",
        currentUserData?.currentUserData?.result?.user_id
      );

      const importcontacts = new BlackList();
      importcontacts
        .importcontactblackbyuserid(formData)
        .then((response) => {
          if (response.isSuccess === true) {
            toast.success(response?.message);
            closeModal();
            props.getAllContacts();
          } else {
            toast.error(response?.message);
          }
        })
        .catch((error) => {
          console.error("Error fetching user profile:", error);
        });
    }
  };

  const HandleDownloadSample = () => {
    const csvData = `contact_name,whatsappno\n abc,91123456789,\n xyz,91987654321`;
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("download", "sample.csv");
    a.setAttribute("href", url);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  return (
    <div>
      <button
        className="ms-3 btn btn-sm btn-neutral rounded-pill"
        onClick={() => {
          setCenteredModal(true);
        }}
      >
        Import Contacts
      </button>

      <Dialog open={centeredModal} onClose={closeModal} maxWidth="md" fullWidth>
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            backgroundColor: "#007bff",
            color: "white",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Import Contacts
          </Typography>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body1" fontWeight={500} gutterBottom>
                Select CSV{" "}
                <span
                  style={{ cursor: "pointer", color: "#6c757d" }}
                  onClick={HandleDownloadSample}
                >
                  (Download Sample)
                </span>
              </Typography>

              <TextField
                fullWidth
                inputRef={fileInputRef}
                onChange={onChangeXLSXFile}
                type="file"
                name="enquiryCSV"
                required
                size="small"
                inputProps={{
                  style: {
                    border: "none",
                    fontSize: "15px",
                    width: "100%",
                    paddingLeft: "5px",
                     accept: ".csv",
                     height:"40px"
                  },
                }}
              />
              <Typography variant="caption" color="error">
                {Errormsg}
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleXlSXUpload}
            variant="contained"
            color="primary"
          >
            Import
          </Button>
          <Button onClick={closeModal} variant="outlined" color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ImportContacts;
